export default "__VITE_ASSET__4vurvN5o__"